import React from "react";

const News = () => {
  return (
    <div className="text-center">
      <h1>News Page</h1>
      <hr></hr>
      <div class="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center bg-light">
        <div className="container">
          <img className="Image" src="./img/futsal.jpg" alt="Image" />
          <p className="caption">
            <b>Nepa Youth club</b> second open futsal tournament program
            organized in the Game futsal Dhaneshor.
          </p>
        </div>
        <div className="container">
          <img className="Image" src="./img/p2.jpg" alt="Image" />
          <p className="caption">
            <b>Nepa Youth club</b> Hiking program to Bishnudwar the source of the Bishnumati river.
          </p>
        </div>
      </div>
    </div>
  );
};

export default News;
